import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CONTENTCATEGORY,
  DELETE_CONTENTCATEGORY,
  UPDATE_CONTENTCATEGORY,
  ADD_NEW_CONTENTCATEGORY,
} from "./actionType";

import {
  getContentCategorySuccess,
  getContentCategoryFail,
  deleteContentCategorySuccess,
  deleteContentCategoryFail,
  updateContentCategorySuccess,
  updateContentCategoryFail,
  addContentCategorySuccess,
  addContentCategoryFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getContentCategoryApi,
  updateContentCategoryApi,
  deleteContentCategoryApi,
  addNewContentCategoryApi
} from "../../helpers/backend_helper";

function* getContentCategory({ payload: contentCategory }) {
  try {
    const response = yield call(getContentCategoryApi, contentCategory);
    yield put(getContentCategorySuccess(GET_CONTENTCATEGORY, response.data));
  } catch (error) {
    yield put(getContentCategoryFail(GET_CONTENTCATEGORY, error));
  }
}

function* onUpdateContentCategory({ payload: contentCategory }) {
  try {
    const response = yield call(updateContentCategoryApi, contentCategory);
    yield put(updateContentCategorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateContentCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteContentCategory({ payload: contentCategory }) {
  try {
    const response = yield call(deleteContentCategoryApi, contentCategory);
    yield put(deleteContentCategorySuccess({ contentCategory, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteContentCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewContentCategory({ payload: contentCategory }) {
  try {
    const response = yield call(addNewContentCategoryApi, contentCategory);
    yield put(addContentCategorySuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addContentCategoryFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetContentCategory() {
  yield takeEvery(GET_CONTENTCATEGORY, getContentCategory);
}

export function* watchUpdateContentCategory() {
  yield takeEvery(UPDATE_CONTENTCATEGORY, onUpdateContentCategory);
}

export function* watchDeleteContentCategory() {
  yield takeEvery(DELETE_CONTENTCATEGORY, onDeleteContentCategory);
}

export function* watchAddNewContentCategory() {
  yield takeEvery(ADD_NEW_CONTENTCATEGORY, onAddNewContentCategory);
}

function* contentCategorySaga() {
  yield all([
    fork(watchGetContentCategory),
    fork(watchDeleteContentCategory),
    fork(watchUpdateContentCategory),
    fork(watchAddNewContentCategory)
  ]);
}

export default contentCategorySaga;
